import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import outline from 'helpers/outline';

export const Wrapper = styled.div`
  padding: 10px 0;
`;

export const Header = styled.button`
  width: 100%;
  column-gap: 10px;
  grid-template-columns: max-content max-content 1fr;
  align-items: center;
  grid-auto-flow: column;
  display: grid;

  padding: 0;
  user-select: none;
  ${transition()};

  text-align: left;
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};

  &:hover,
  &:focus-visible {
    color: ${({theme}) => `
      ${transparentize(.5, theme.variables.color)};
    `};
  }

  &:active {
    color: ${({theme}) => `
      ${transparentize(.3, theme.variables.color)};
    `};
  }

  &:focus-visible {
    color: ${({theme}) => theme.colors.primary};
  }

  &:after {
    content: "";

    width: 100%;
    margin-top: 4px;
    border-bottom: 1px dashed ${({theme}) => `
      ${transparentize(.85, theme.variables.color)};
    `};
  }
`;

export const IconContainer = styled.div<{
  controlsVisibility?: boolean;
}>`
  display: grid;
  ${transition()};
  color: ${({theme}) => `
    ${transparentize(.85, theme.variables.color)};
  `};
  
  ${({controlsVisibility}) => controlsVisibility && css`
    transform: rotate(45deg);
  `};
`;

export const Controls = styled.div`
  margin-top: 10px;
  column-gap: 6px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Control = styled.button`
  padding: 6px 10px;
  box-sizing: border-box;
  border-radius: 6px;

  font-size: 12px;
  line-height: 16px;

  ${transition()};
  user-select: none;

  background: ${({theme}) => `
    ${transparentize(.9, theme.variables.color)};
  `};

  &:hover {
    background: ${({theme}) => `
      ${transparentize(.8, theme.variables.color)};
    `};
  }

  &:active {
    background: ${({theme}) => `
      ${transparentize(.7, theme.variables.color)};
    `};
  }

  &:focus-visible {
    ${outline(4, 1)};
  }
`;
